<template>
    <div v-if="!loading" class="pb-2">
        <b-alert variant="info" show>
            <p class="alert-body text-center mb-2">
                برای ایجاد کلید سیستمی ابتدا می‌بایست برنامه
                <a :href="`${BASE_URL_File}static/printer.zip`" download class="font-weight-bolder"> QZ Tray </a>
                را دانلود و در سیستم خود نصب کنید.
            </p>
        </b-alert>
        <div class="d-flex justify-content-between align-items-center mb-2 mx-50">
            <h3 class="text-primary mb-0">کلید های سیستمی</h3>
            <b-button @click="$bvModal.show('create-system-key')" variant="primary">
                افزودن کلید
            </b-button>
        </div>
        <div>
            <div>
                <b-card v-if="systemKeyData.length" class="p-0" no-body>
                    <b-table responsive :items="systemKeyData" :fields="fieldsSystemKey" class="mb-0">
                        <template #cell(createdAt)="data">
                            {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                        </template>
                        <template #cell(edit)="data">
                            <feather-icon @click="editSystemKeyModal(data.item)" size="18" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(delete)="data">
                            <feather-icon @click="deleteSystemKeyModal(data.item.id)" size="19" icon="XCircleIcon"
                                class="pointer text-danger" color="#8d88a3" />
                        </template>
                    </b-table>
                </b-card>
                <b-card v-else class="text-center py-5">
                    موردی وجود ندارد
                </b-card>
            </div>
        </div>


        <hr class="mt-3 mb-2">

        <div class="d-flex justify-content-between align-items-center mb-2 mx-50">
            <h3 class="text-primary mb-0">چاپگر ها</h3>
            <b-button :disabled="!systemKeyData.length" @click="$bvModal.show('key-selection')" variant="primary">
                ایجاد چاپگر
            </b-button>
        </div>
        <div>
            <div>
                <b-card v-if="printers.length" class="p-0" no-body>
                    <b-table responsive :items="printers" :fields="fieldsPrinters" class="mb-0">
                        <template #cell(edit)="data">
                            <feather-icon @click="editPrinterKeyHandle(data.item)" size="18" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(delete)="data">
                            <feather-icon @click="deletePrinterModal(data.item.id)" size="19" icon="XCircleIcon"
                                class="pointer text-danger" color="#8d88a3" />
                        </template>
                    </b-table>
                </b-card>
                <b-card v-else class="text-center py-5">
                    موردی وجود ندارد
                </b-card>
            </div>
        </div>


        <!-------------------------------------- modal select system key for edit -------------------------------------->
        <b-modal id="edit-key-selection" title="انتخاب کلید سیستمی" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <div class="p-1">
                <div class="mb-2">
                    <b-form-group label="کلید سیستمی">
                        <v-select v-model="printerForm.systemKey" dir="rtl" :options="systemKeyData"
                            :reduce="(value) => value" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </div>
                <b-button @click="editPrinterModal" variant="primary"
                    :disabled="loadingButton || !printerForm.systemKey.name"
                    class="d-flex align-items-center justify-content-center w-100 mt-3">
                    <b-spinner v-if="loadingButton" variant="white" class="mr-50" small></b-spinner>
                    <span>تایید</span>
                </b-button>
            </div>
        </b-modal>


        <!-------------------------------------- modal select system key for create -------------------------------------->
        <b-modal id="key-selection" title="انتخاب کلید سیستمی" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <div class="p-1">
                <div class="mb-2">
                    <b-form-group label="کلید سیستمی">
                        <v-select v-model="printerForm.systemKey" dir="rtl" :options="systemKeyData"
                            :reduce="(value) => value" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </div>
                <b-button @click="createPrinterModal" variant="primary"
                    :disabled="loadingButton || !printerForm.systemKey.name"
                    class="d-flex align-items-center justify-content-center w-100 mt-3">
                    <b-spinner v-if="loadingButton" variant="white" class="mr-50" small></b-spinner>
                    <span>تایید</span>
                </b-button>
            </div>
        </b-modal>

        <!------------------------------- modal handle printer ------------------------------->
        <b-modal id="handle-printer" :title="printerMode == 'create' ? 'ایجاد چاپگر' : 'ویرایش چاپگر'" centered
            :hide-footer="true" title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <p class="text-center text-warning mb-2 h5">
                    انتخاب محصولات برای چاپ خودکار فیش سفارش می‌باشد. در صورتی که این چاپگر برای چاپ فاکتور صندوق
                    است، نیازی
                    به انتخاب محصولات نیست.
                </p>
                <div class="mb-2">
                    <b-form-group label="انتخاب محصولات">
                        <v-select v-model="printerForm.productsIds" dir="rtl" multiple :options="allProducts"
                            :reduce="(value) => value.id" label="name_Fa" :clearable="false" :closeOnSelect="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="mb-2">
                    <b-form-group label="انتخاب پرینتر">
                        <v-select v-model="printerForm.printer" dir="rtl" :options="printerList"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="mb-2">
                    <b-form-group label="نام چاپگر">
                        <b-form-input v-model="printerForm.name"></b-form-input>
                    </b-form-group>
                </div>
                <div class="mb-2">
                    <b-form-group label="کلید سیستمی">
                        <b-form-input v-model="printerForm.systemKey.name" disabled></b-form-input>
                    </b-form-group>
                </div>
                <b-button @click="handleMethodPrinter" variant="primary" :disabled="loadingButton"
                    class="d-flex align-items-center justify-content-center w-100 mt-3">
                    <b-spinner v-if="loadingButton" variant="white" class="mr-50" small></b-spinner>
                    <span>{{ printerMode == 'create' ? 'ایجاد' : 'ویرایش' }}</span>
                </b-button>
            </div>
        </b-modal>



        <!------------------------------- modal create system key ------------------------------->
        <b-modal id="create-system-key" title="افزودن کلید" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <div class="mb-2">
                    <b-form-group label="نام کلید">
                        <b-form-input class="text-center" v-model="systemKeyForm.name"></b-form-input>
                    </b-form-group>
                </div>
                <div class="mb-2">
                    <b-form-group label="کلید گواهی (digital-certificate)">
                        <b-form-file browse-text="بارگذاری" v-model="systemKeyForm.certificateKey"
                            :disabled="loadingButton" placeholder="" />
                    </b-form-group>
                </div>
                <div>
                    <b-form-group label="کلید خصوصی (private-key)">
                        <b-form-file browse-text="بارگذاری" v-model="systemKeyForm.privateKey" :disabled="loadingButton"
                            placeholder="" />
                    </b-form-group>
                </div>
                <b-button @click="createSystemKey" variant="primary" :disabled="loadingButton"
                    class="d-flex align-items-center justify-content-center w-100 mt-3">
                    <b-spinner v-if="loadingButton" variant="white" class="mr-50" small></b-spinner>
                    <span>افزودن</span>
                </b-button>
            </div>
        </b-modal>


        <!------------------------------- modal edit system key ------------------------------->
        <b-modal id="edit-system-key" title="ویرایش کلید" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <div class="p-1">
                <div class="mb-2">
                    <b-form-group label="نام کلید">
                        <b-form-input class="text-center" v-model="systemKeyFormEdit.name"></b-form-input>
                    </b-form-group>
                </div>
                <div class="mb-2">
                    <b-form-group label="کلید گواهی (digital-certificate)">
                        <b-form-file browse-text="بارگذاری" v-model="systemKeyFormEdit.certificateKey"
                            :disabled="loadingButton" placeholder="" />
                    </b-form-group>
                </div>
                <div>
                    <b-form-group label="کلید خصوصی (private-key)">
                        <b-form-file browse-text="بارگذاری" v-model="systemKeyFormEdit.privateKey"
                            :disabled="loadingButton" placeholder="" />
                    </b-form-group>
                </div>
                <b-button @click="editSystemKey" variant="primary" :disabled="loadingButton"
                    class="d-flex align-items-center justify-content-center w-100 mt-3">
                    <b-spinner v-if="loadingButton" variant="white" class="mr-50" small></b-spinner>
                    <span>ویرایش</span>
                </b-button>
            </div>
        </b-modal>

        <!-------------------------------------- modal delete system key -------------------------------------->
        <b-modal id="delete-system-key" title="حذف کلید" centered :hide-footer="true" title-class="font-weight-bolder">
            <div class="p-1">
                <h5 class="text-center text-danger mb-3 mt-1">با حذف این کلید، تمامی چاپگر های مرتبط حذف
                    خواهند شد.</h5>
                <div class="d-flex align-items-center">
                    <b-button @click="$bvModal.hide('delete-system-key')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button :disabled="loadingButton" @click="deleteSystemKey()" class="w-50" variant="danger">
                        حذف
                    </b-button>
                </div>
            </div>
        </b-modal>


        <!-------------------------------------- modal delete printer -------------------------------------->
        <b-modal id="delete-printer-modal" title="حذف چاپگر" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <div class="p-1">
                <h5 class="text-center text-danger mb-3 mt-1">
                    آیا از حذف این چاپگر مطمئن هستید؟
                </h5>
                <div class="d-flex align-items-center">
                    <b-button @click="$bvModal.hide('delete-printer-modal')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button :disabled="loadingButton" @click="deletePrinter()" class="w-50" variant="danger">
                        حذف
                    </b-button>
                </div>
            </div>
        </b-modal>


    </div>
</template>

<script>
import { BCard, BCardText, BRow, BCol, BButton, BAvatar, BTable, BFormInput, BFormGroup, BFormFile, BSpinner, BAlert, BFormCheckbox, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import qz from 'qz-tray';

export default {
    components: {
        BCard,
        BCardText,
        BRow,
        BCol,
        BButton,
        BAvatar,
        BTable,
        BFormInput,
        BFormGroup,
        BFormFile,
        BSpinner,
        BAlert,
        BFormCheckbox,
        BBadge,
        vSelect,
    },
    data() {
        return {
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            storeId: null,
            loading: true,
            loadingButton: false,
            fieldsSystemKey: [
                {
                    key: 'name',
                    label: 'نام کلید',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ایجاد',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
                {
                    key: 'delete',
                    label: 'حذف',
                },
            ],
            fieldsPrinters: [
                {
                    key: 'name',
                    label: 'نام چاپگر',
                },
                {
                    key: 'model',
                    label: 'مدل پرینتر',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
                {
                    key: 'delete',
                    label: 'حذف',
                },
            ],
            deleteSystemKeyId: null,
            deletePrinterId: null,
            systemKeyData: [],
            printerList: [],
            printers: [],
            printerForm: {
                name: null,
                systemKey: {
                    id: null,
                    name: null,
                    createdAt: null,
                },
                printer: null,
                productsIds: [],
            },
            allProducts: [],
            systemKeyFormEdit: {
                id: null,
                name: null,
                privateKey: null,
                certificateKey: null
            },
            systemKeyForm: {
                name: null,
                privateKey: null,
                certificateKey: null
            },
            activeKey: null,
            editCertificateId: null,
            currentPrinterId: null,
            printerMode: 'create',
        }
    },
    methods: {
        handleMethodPrinter() {
            if (this.printerMode == 'create') {
                this.createPrinter()
            }
            if (this.printerMode == 'edit') {
                this.editPrinter()
            }
        },
        editPrinterKeyHandle(item) {
            this.printerForm.name = item.name
            this.printerForm.printer = item.model
            this.printerForm.productsIds = item.productsIds
            this.editCertificateId = item.certificateId
            this.currentPrinterId = item.id
            this.$bvModal.show('edit-key-selection')
        },
        editPrinterModal() {
            this.printerMode = 'edit'
            if (this.editCertificateId == this.printerForm.systemKey.id) {
                this.loadingButton = true
                this.activeKey = this.printerForm.systemKey.id
                if (qz.websocket.isActive()) {
                    qz.websocket.disconnect();
                }
                this.connectQZ('edit');
            }
            else {
                this.$notif({ type: 'error', title: 'لطفا از سیستم مربوطه اقدام به ویرایش چاپگر مورد نظر کنید' });
            }
        },
        editPrinter() {
            this.loadingButton = true
            let data = {}
            data.certificateId = this.printerForm.systemKey.id
            data.name = this.printerForm.name
            data.model = this.printerForm.printer
            data.productsIds = this.printerForm.productsIds
            storeService.editPrinter(this.storeId, this.currentPrinterId, data).then(({ data }) => {
                this.printerForm.productsIds = []
                this.printerForm.printer = null
                this.printerForm.name = null
                this.printerForm.systemKey = {
                    id: null,
                    name: null,
                    createdAt: null,
                }
                this.$bvModal.hide('handle-printer')
                this.$notif({ type: 'success' });
                this.loadingButton = false
                this.getPrinter()
            })
                .catch((err) => {
                    this.loadingButton = false
                    this.$notif({ type: 'error' });
                })
        },
        createPrinterModal() {
            this.loadingButton = true
            this.printerForm.productsIds = []
            this.printerForm.printer = null
            this.printerForm.name = null
            this.printerMode = 'create'
            this.activeKey = this.printerForm.systemKey.id
            if (qz.websocket.isActive()) {
                qz.websocket.disconnect();
            }
            this.connectQZ('create');
        },
        createPrinter() {
            let data = {}
            data.certificateId = this.printerForm.systemKey.id
            data.name = this.printerForm.name
            data.model = this.printerForm.printer
            data.productsIds = this.printerForm.productsIds
            storeService.createPrinters(this.storeId, data).then(({ data }) => {
                this.printerForm.productsIds = []
                this.printerForm.printer = null
                this.printerForm.name = null
                this.printerForm.systemKey = {
                    id: null,
                    name: null,
                    createdAt: null,
                }
                this.$bvModal.hide('handle-printer')
                this.$notif({ type: 'success' });
                this.getPrinter()
            })
                .catch((err) => {
                    this.loadingButton = false
                    this.$notif({ type: 'error' });
                })
        },
        deletePrinter() {
            this.loadingButton = true
            storeService.deletePrinter(this.storeId, this.deletePrinterId).then(({ data }) => {
                this.deletePrinterId = null
                this.$bvModal.hide('delete-printer-modal')
                this.loadingButton = false
                this.$notif({ type: 'success' });
                this.getPrinter()
            })
                .catch((err) => {
                    this.loadingButton = false
                    this.$notif({ type: 'error' });
                })
        },
        deletePrinterModal(id) {
            this.deletePrinterId = id
            this.$bvModal.show('delete-printer-modal')
        },
        deleteSystemKeyModal(id) {
            this.deleteSystemKeyId = id
            this.$bvModal.show('delete-system-key')
        },
        getProductPrinterStatus(type) {
            storeService.productPrinterStatus(this.storeId).then(({ data }) => {
                if (type == 'create') {
                    this.allProducts = []
                    if (data.items.length) {
                        data.items.forEach(product => {
                            if (product.printerId == null) {
                                this.allProducts.push({
                                    id: product.id,
                                    name_Fa: product.name_Fa
                                })
                            }
                        });
                    }
                    this.loadingButton = false
                    this.$bvModal.hide('key-selection')
                    this.$bvModal.show('handle-printer')
                }
                if (type == 'edit') {
                    this.allProducts = []
                    if (data.items.length) {
                        data.items.forEach(product => {
                            if (product.printerId == null || product.printerId == this.currentPrinterId) {
                                this.allProducts.push({
                                    id: product.id,
                                    name_Fa: product.name_Fa
                                })
                            }
                        });
                    }
                    this.loadingButton = false
                    this.$bvModal.hide('edit-key-selection')
                    this.$bvModal.show('handle-printer')
                }
            })
        },
        deleteSystemKey() {
            this.loadingButton = true
            storeService.printerDeleteSystemKey(this.storeId, this.deleteSystemKeyId).then(({ data }) => {
                this.deleteSystemKeyId = null
                this.$bvModal.hide('delete-system-key')
                this.loadingButton = false
                this.$notif({ type: 'success' });
                this.getSystemKey()
            })
                .catch((err) => {
                    this.loadingButton = false
                    this.$notif({ type: 'error' });
                })
        },
        editSystemKeyModal(item) {
            this.systemKeyFormEdit.name = item.name
            this.systemKeyFormEdit.id = item.id
            this.$bvModal.show('edit-system-key')
        },
        editSystemKey() {
            this.loadingButton = true
            let formData = new FormData();
            formData.append("name", this.systemKeyFormEdit.name)
            formData.append("privateKey", this.systemKeyFormEdit.privateKey)
            formData.append("certificateKey", this.systemKeyFormEdit.certificateKey)
            storeService.printerEditSystemKey(this.storeId, this.systemKeyFormEdit.id, formData).then(({ data }) => {
                this.systemKeyFormEdit.name = null
                this.systemKeyFormEdit.privateKey = null
                this.systemKeyFormEdit.certificateKey = null
                this.$bvModal.hide('edit-system-key')
                this.loadingButton = false
                this.$notif({ type: 'success' });
                this.getSystemKey()
            })
                .catch((err) => {
                    this.loadingButton = false
                    this.$notif({ type: 'error' });
                })
        },
        createSystemKey() {
            this.loadingButton = true
            let formData = new FormData();
            formData.append("name", this.systemKeyForm.name)
            formData.append("privateKey", this.systemKeyForm.privateKey)
            formData.append("certificateKey", this.systemKeyForm.certificateKey)
            storeService.createSystemKey(this.storeId, formData).then(({ data }) => {
                this.systemKeyForm.name = null
                this.systemKeyForm.privateKey = null
                this.systemKeyForm.certificateKey = null
                this.$bvModal.hide('create-system-key')
                this.loadingButton = false
                this.$notif({ type: 'success' });
                this.getSystemKey()
            })
                .catch((err) => {
                    this.loadingButton = false
                    this.$notif({ type: 'error' });
                })
        },
        getSystemKey() {
            storeService.systemKey(this.storeId).then(({ data }) => {
                this.systemKeyData = data.items
                this.getPrinter()
            })
        },
        getPrinter() {
            storeService.getPrinter(this.storeId).then(({ data }) => {
                this.printers = data.items
                this.loading = false
            })
        },
        connectQZ(type) {
            storeService.printerCertificateKey(this.storeId, this.activeKey).then(({ data }) => {
                qz.security.setCertificatePromise((resolve, reject) => {
                    resolve(data);
                });
                qz.websocket.connect().then(() => {
                    qz.printers.find().then(printers => {
                        for (let index in printers) {
                            this.printerList[index] = {
                                name: printers[index],
                                id: printers[index],
                            }
                        }
                        if (type == 'create') {
                            this.getProductPrinterStatus('create')
                        }
                        if (type == 'edit') {
                            this.getProductPrinterStatus('edit')
                        }
                    }).catch(err => {
                        this.$notif({ type: 'error', title: 'مشکل در دریافت لیست پرینتر ها' });
                    });
                    this.loading = false
                    qz.security.setSignatureAlgorithm("SHA512");
                    qz.security.setSignaturePromise((message) => {
                        return (resolve, reject) => {
                            storeService.printerSignatureMessage(this.storeId, this.activeKey, message).then(({ data }) => {
                                resolve(data);
                            });
                        };
                    });
                })
                    .catch(err => {
                        this.loadingButton = false
                        this.$notif({ type: 'error', title: 'مشکل در اتصال به پرینتر' });
                    });
            })
                .catch(err => {
                    this.loadingButton = false
                });
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        if (qz.websocket.isActive()) {
            qz.websocket.disconnect();
        }
        this.getSystemKey()
    },
    beforeDestroy() {
        if (qz.websocket.isActive()) {
            qz.websocket.disconnect();
        }
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>